import marketingManagementTypes from "../actions/types/marketingManagement.action.type";

export const loginMessageManagementInitialState = {
  getDashboardMessage: null,
  getDashboardError: null,

  getDashboardQueueError: null,
  getDashboardQueueMessage: null,

  createDashboardMessage: null,
  createDashboardError: null,

  approveDashboardMessage: null,
  approveDashboardError: null,

  declineDashboardMessage: null,
  declineDashboardError: null,
};

export default function loginMessageManagementReducer(
  state = loginMessageManagementInitialState,
  action
) {
  switch (action.type) {
    case marketingManagementTypes.GET_LOGIN_MESSAGE_SUCCESS:
      return {
        ...state,
        getDashboardMessage: action.data,
        getDashboardError: null,
        createDashboardMessage: null,
        createDashboardError: null,
      };
    case marketingManagementTypes.GET_LOGIN_MESSAGE_FAILURE:
      return {
        ...state,
        getDashboardMessage: null,
        getDashboardError: action.error,
        createDashboardMessage: null,
        createDashboardError: null,
      };
    case marketingManagementTypes.GET_LOGIN_QUEUE_MESSAGE_SUCCESS:
      return {
        ...state,
        getDashboardQueueMessage: action.data,
        getDashboardQueueError: null,

        approveDashboardMessage: null,
        approveDashboardError: null,

        declineDashboardMessage: null,
        declineDashboardError: null,
      };
    case marketingManagementTypes.GET_LOGIN_QUEUE_MESSAGE_FAILURE:
      return {
        ...state,
        getDashboardQueueMessage: null,
        getDashboardQueueError: action.error,

        approveDashboardMessage: null,
        approveDashboardError: null,

        declineDashboardMessage: null,
        declineDashboardError: null,
      };

    case marketingManagementTypes.CREATE_LOGIN_MESSAGE_SUCCESS:
      return {
        ...state,
        createDashboardMessage: action.data,
        createDashboardError: null,
      };
    case marketingManagementTypes.CREATE_LOGIN_MESSAGE_FAILURE:
      return {
        ...state,
        createDashboardMessage: null,
        createDashboardError: action.error,
      };
    case marketingManagementTypes.APPROVE_LOGIN_MESSAGE_SUCCESS:
      return {
        ...state,
        approveDashboardMessage: action.data,
        approveDashboardError: null,

        declineDashboardMessage: null,
        declineDashboardError: null,
      };
    case marketingManagementTypes.APPROVE_LOGIN_MESSAGE_FAILURE:
      return {
        ...state,
        approveDashboardMessage: null,
        approveDashboardError: action.error,
        declineDashboardMessage: null,
        declineDashboardError: null,
      };
    case marketingManagementTypes.DECLINE_LOGIN_MESSAGE_SUCCESS:
      return {
        ...state,
        declineDashboardMessage: action.data,
        declineDashboardError: null,

        approveDashboardMessage: null,
        approveDashboardError: null,
      };
    case marketingManagementTypes.DECLINE_LOGIN_MESSAGE_FAILURE:
      return {
        ...state,
        declineDashboardMessage: null,
        declineDashboardError: action.error,

        approveDashboardMessage: null,
        approveDashboardError: null,
      };
    default:
      return state;
  }
}
